
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/apps-integrations/detail",
      function () {
        return require("private-next-pages/apps-integrations/detail/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/apps-integrations/detail"])
      });
    }
  